module.exports = __webpack_public_path__ + "static/img/computer_science_heading.81bb4b09.png";